module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sbox"
  }, [_c('h2', {
    staticClass: "subchapter",
    attrs: {
      "id": "s002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Berry Breakfast Casserole")])])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Yield: Serves 6 | Prep Time: 20 minutes | Cook Time: 40 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "recipenote"
  }, [_vm._v("This casserole looks and tastes like a blondie, but it’s packed with oats and superfood berries. Prepare it in the morning before guests arrive. If you have a few stragglers, pop the casserole back in the oven to reheat when everyone is ready to eat. If there is any left after breakfast, this makes for one of my favorite afternoon snacks served with yogurt and honey.")])]), _vm._v(" "), _c('p', {
    staticClass: "serves"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "indger1"
  }, [_vm._v("1 cup old-fashioned rolled oats")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup steel-cut oats")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 teaspoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 large egg")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup whole milk")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("¼ cup vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup blueberries")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup raspberries")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ cup dried cranberries")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ cup coarsely chopped pecans")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup strawberries, hulled and quartered")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("Yogurt and honey, for serving")]), _vm._v(" "), _c('h2', {
    staticClass: "Directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("1. Preheat the oven to 350°F and lightly coat an 8 × 8-inch baking dish with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("2. In a large bowl, combine the oats, flour, brown sugar, baking powder, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("4. Beat the egg in a small bowl, add the milk, oil, and vanilla, and mix well. Stir the wet ingredients into the dry, add the blueberries, raspberries, cranberries, and pecans, and mix until well blended.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("4. Pour into the baking dish and bake for 40 minutes. Remove from the oven and top with the sliced strawberries. Cut into squares and serve warm with yogurt and honey.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c53f376","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/s002.vue
// module id = 87
// module chunks = 0